<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:00em;">To the headmaster and deputy headmaster of the school where I spent many happy and hard-working years: thank you for helping me fulfil my dreams.</p>
<br/><p style="text-indent:00em;">To my husband, children and wonderful grandchildren: thank you for your on-going love and support. You are my world. I love each of you so very much!</p>
<br/><p style="text-indent:00em;">To all teachers everywhere: Love your students, care for them like your own family, and never give up on trying to “find a way” to connect with them and inspire them.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6b7bd7fa